/* 
-----------------------------------------------------------------------------
| TABLE LAYOUT PAGE
-----------------------------------------------------------------------------
- description: no booking data logic goes here, just metrics, redirects etc.
*/
import { FC, useEffect } from "react";
import { Aside } from "../components/table-layout/aside/Aside";
import { useApp } from "../context/useApp";
import { metrics, ROUTES, voiceAssistant } from "../utils/symbols";
import { _ } from "../utils/helpers";
import { StepControls } from "../components/table-layout/aside/StepControls";
import { TicketSelection } from "../components/TicketsSelection";

export const TableLayoutPage: FC = () => {

    const {
        state: { booking },
        actions: { navigate }
    } = useApp()

    useEffect(() => {

        if (booking.step === 'date') {navigate(ROUTES.DATE); return}

    }, [])

    const label = (() => {
        let base = 'to continue with the booking '
        switch (booking.step) {
            case 'shift': return base + _('2sh_selec_s')
            case 'tickets': return base + _('3zo_selec_z')
            case 'products': return _('3zo_tocon__')
            default: return base
        }
    })()

    return (
        <main 
            id="table-layout-page" 
            className={`page-container p-r ${booking.step}`} 
            aria-live="assertive"
            aria-label={label}

        >
            <div className="df jcsb aic w-100 h-100 content">
                <StepControls />
                <TicketSelection />
                <Aside />
            </div>
        </main>
    )
}